
define('text!templates/modules/setting/business/blocks/brand/url-edit-form.html',[],function () { return '<div class="url-text"></div>\n<div class="url-text-preview"></div>\n<div class="line-with-space"></div>\n<div class="background-image"></div>\n<div class="background-image-preview hide"></div>\n';});

